module.exports = __webpack_public_path__ + "img/subscription-paper-plane.d2a7b03e.png";